import { mapMutations, mapState } from 'vuex'
import { audioInstance } from '../../services/AudioService'

const audio = audioInstance()

export default {
  computed: {
    ...mapState('appStates', [
      'audioPlayerIsLoading',
      'audioPlayerIsPlaying',
      'audioPlayerFileKey',
    ]),
    ...mapState('languagesStates', [
      'translatedStringLoading',
      'translatedStrings',
    ]),
  },
  methods: {
    ...mapMutations('appStates', [
      'setAudioPlayerIsPlaying',
      'setAudioPlayerIsLoading',
      'setAudioPlayerFileKey',
    ]),
    stopAudio() {
      audio.stopAudio()
      this.setAudioPlayerIsPlaying(false)
      this.setAudioPlayerIsLoading(false)
      this.setAudioPlayerFileKey(null)
    },
    playAudio(fileBinary, fileKey, onEnd = () => {}, onStart = () => {}) {
      try {
        audio.stopAudio()
        this.setAudioPlayerIsLoading(true)
        this.setAudioPlayerFileKey(fileKey)
        audio.playAudio(
          fileBinary,
          fileKey,
          () => {
            this.setAudioPlayerIsPlaying(false)
            onEnd()
          },
          () => {
            this.setAudioPlayerIsLoading(false)
            this.setAudioPlayerIsPlaying(true)
            onStart()
          },
        )
      } catch (error) {
        console.log('error play audio', error)
        this.stopAudio()
      }
    },
  },
}
